import React from 'react';
import { LyricsDisplay } from './LyricsDisplay';
type ChordedLyricsProps = {
  lyrics: string[];
  chords: string[];
  activeLine?: number;
  onLineClick?: (index: number) => void;
  attribution?: string;
};
export const ChordedLyrics = ({
  lyrics,
  chords,
  activeLine,
  onLineClick,
  attribution
}: ChordedLyricsProps) => {
  // Format lyrics with chords positioned above specific words
  const formattedLyrics = lyrics.map((line, index) => {
    const chord = chords[index];
    if (!chord) return line;
    // Define chord positions relative to words in each line
    const chordPositions = {
      1: [{
        chord: 'Em',
        word: 0
      }],
      2: [{
        chord: 'C',
        word: 0
      }, {
        chord: 'G',
        word: 2
      }],
      3: [{
        chord: 'Am',
        word: 0
      }, {
        chord: 'Em',
        word: 3
      }],
      4: [{
        chord: 'C',
        word: 0
      }, {
        chord: 'G',
        word: 2
      }],
      5: [{
        chord: 'Am',
        word: 0
      }, {
        chord: 'Em',
        word: 3
      }],
      6: [{
        chord: 'C',
        word: 0
      }, {
        chord: 'G',
        word: 2
      }, {
        chord: 'D',
        word: 4
      }],
      7: [{
        chord: 'Em',
        word: 0
      }] // "So"
    };
    const positions = chordPositions[index] || [];
    const words = line.split(' ');
    let result = '';
    words.forEach((word, wordIndex) => {
      const chordForWord = positions.find(p => p.word === wordIndex);
      const chord = chordForWord ? `<span class="absolute -top-8 left-0 text-[#1DB954] text-base font-bold font-mono">${chordForWord.chord}</span>` : '';
      result += `<span class="inline-block relative mr-2">${chord}${word}</span>`;
    });
    return `<div class="relative pt-8 leading-relaxed">${result}</div>`;
  });
  return <div className="w-full font-sans text-2xl" data-id="element-13">
      <div className="space-y-6" data-id="element-14">
        {formattedLyrics.map((line, index) => <div key={index} className={`cursor-pointer transition-opacity duration-200 ${activeLine === index ? 'opacity-100' : 'opacity-70 hover:opacity-90'}`} onClick={() => onLineClick?.(index)} dangerouslySetInnerHTML={{
        __html: line
      }} data-id="element-15" />)}
      </div>
      {attribution && <div className="mt-8 text-sm text-[#b3b3b3]" data-id="element-16">{attribution}</div>}
      <div className="mt-4 text-[#b3b3b3] text-sm" data-id="element-17">
        <p data-id="element-18">Tap on a line to see chord details for piano and guitar</p>
      </div>
    </div>;
};